import { useMutation, useQueryClient } from '@tanstack/react-query';

import dealPageService from '~/services/cruises/DealPageService';

import { dealPageQueryKeys } from './dealPageQueryKeys';

export function useCloneDealPage() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (dealId: string) => dealPageService.cloneById(dealId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: dealPageQueryKeys.lists() });
    },
  });
}
